<template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <CuponDescuentoComponent
                    :cart_id="cart_id"
                    :loading="loading"
                    :esMovil="esMovil"
                    @setDescuento="setDescuento"
                    @desactivarCuponGeneral="desactivarCuponGeneral"
                />
            </b-col>
            <b-col cols="12" md="8" class="mt-3">
                <ul v-for="(item, index) in items" :key="index" class="resumen d-md-flex">
                    <li class="altcolor-content">
                        <div class="text-bold oswald text-uppercase m-0 w-100">
                            {{ index + 1 }}. {{ item.precio.amount | formatear_precio }}
                        </div>
                    </li>
                    <li>
                        <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                            {{ item.zona.name }}
                        </div>
                    </li>
                    <li class="flex-grow-1">
                        <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                            {{ $t('general.fila') }}: {{ item.row }} - {{ $t('general.butaca') }}: {{ item.seat }}
                        </div>
                    </li>
                    <li class="text-bold pr-0 pl-0">
                        <label class="h5 pr-0">{{ $t('general.precio') }}</label>
                        <div class="h5 m-lg-0">
                            <template v-if="item.discount && item.discount.percentage > 0">
                                <span>
                                    {{ getTotal(item) | formatear_precio }} 
                                </span>
                                <span>
                                    <small>(<del>{{ item.precio.amount | formatear_precio }}</del>)</small>
                                </span>
                            </template>
                            <template v-else>
                                {{ getTotal(item) | formatear_precio }}
                            </template>
                        </div>
                        <template v-if="item.discount">
                            <div class="text-small text-success pt-1">
                                {{ item.discount.name }}
                            </div>
                        </template>                        
                    </li>
                </ul>
                <div class="mb-5">
                    <label>{{ $t('evento.total_pagar') }}</label>
                    <div class="price price-large gradient-color">
                        {{ total_con_gastos | formatear_precio }}
                    </div>
                </div>
            </b-col>

            <b-col cols="12">
                <FormTerminos
                    :error="error"
                    :desactivar="loading"
                    @continuar="aceptarCondiciones"
                />
            </b-col>

            <ResumenPrecioComponent
                :price="total_sin_gastos"
                :price_management="total_gastos"
                :price_management_interno="items[0]?.precio?.price_management_interno"
                :iva="footer.iva_partido"
            />

            

            <b-col cols="12" class="mt-3 d-flex justify-content-start flex-wrap">
                <button 
                    id="resumen-compra-responsive" 
                    :class="['button', 'effect-button', { 'large-button': !esMovil }]" 
                    :disabled="(formulario && pagar) || loading"
                    @click.prevent="terminar"
                >
                    <span>{{ $t('partido.continuar') }}</span>
                </button>

                <button
                    id="atras-resumen"
                    type="button"
                    :disabled="(formulario && pagar) || loading" 
                    :class="['button', 'effect-button', 'ml-2', 'compra-responsive', { 'large-button': !esMovil }]"
                    @click="volver()"
                >
                    <span>{{ $t('formularios.atras') }}</span>
                </button>

                <template v-if="formulario && pagar">
                    <div id="formulario-compra" v-html="formulario" v-show="false"></div>
                </template>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import CuponDescuentoComponent from './CuponDescuentoComponent';
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import ResumenPrecioComponent from '@/components/frontend/compra/components/ResumenPrecioComponent';

    export default {
        name: 'ResumenCompraComponent',
        props: {
            items: {
                type: Array,
                required: true
            },
            jet_id: {
                type: String,
                default: null
            },
            formulario: {
                type: String,
                default: null
            },
            cart_id: {
                type: [String, Number],
                default: null
            }
        },
        data() {
            return {
                pagar: false,
                error: false,
                loading: false,
                terminos: false,
                privacidad: false,
                condiciones: false,
                comunicaciones: false,
                descuentos_condicionales: []
            };
        },
        created() {
            this.getDescuentosCondicionales();
        },
        methods: {
            async terminar() {
                this.loading = true;

                if (!this.terminos) {
                    this.error = true;
                    this.loading = false;
                    return;
                }

                const exito = await this.guardarTerminosCondiciones();
                if (!exito) return;

                this.pagar = true;

                if (this.formulario && this.pagar) {
                    setTimeout(() => {
                        const btn = document.getElementById('btn-pagar');
                        if (btn) btn.click();
                    }, 500);
                } else {
                    this.$emit('terminado');
                }

                this.loading = false;
            },
            getTotal(item, con_gastos = false) {
                let precio = item.precio.amount;

                if (item.discount && item.discount.percentage > 0) {
                    precio = precio - (precio * item.discount.percentage / 100);
                }

                if (con_gastos && !item.precio.price_management_online) {
                    precio += item.precio.price_management;
                }

                return precio;
            },
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
                this.terminos = continuar;
                this.privacidad = privacidad;
                this.condiciones = condiciones;
                this.comunicaciones = comunicaciones;
            },
            async guardarTerminosCondiciones() {
                try {
                    await this.$store.dispatch(this.config.getVuexAlias('sga.cart.guardar-condiciones'), {
                        filters: {},
                        cart_id: this.cart_id,
                        privacidad: this.privacidad,
                        condiciones: this.condiciones,
                        comunicaciones: this.comunicaciones
                    });
                    return true;
                } catch (error) {
                    this.$toast.error('No se han podido guardar las condiciones: ' + error.response?.data?.message);
                    this.loading = false;
                    return false;
                }
            },
            getDescuentosCondicionales() {
                this.loading = true;

                this.$store.dispatch(this.config.getVuexAlias('sga.cart.get.descuentos'), {
                    cart_id: this.cart_id,
                }).then(res => {
                    this.descuentos_condicionales = res.data.data;

                    let applied = false;
                    const appliedLicensorIds = new Set();

                    this.descuentos_condicionales.forEach(descuento => {
                        let descuento_disponible = descuento.discounts?.find(d => {
                            return d.limit > 0 && !appliedLicensorIds.has(d.licensorEntitlementId);
                        });

                        if(!descuento_disponible) return;

                        this.items.forEach(item => {
                            if (!item.discount && item.id === descuento.cart_item_sga_id) {
                                this.$set(item, 'discount', {
                                    id: descuento_disponible.id,
                                    percentage: descuento_disponible.percentage,
                                    name: descuento_disponible.name,
                                    licensorEntitlementId: descuento_disponible.licensorEntitlementId
                                });
                                applied = true;
                                appliedLicensorIds.add(descuento_disponible.licensorEntitlementId);
                            }
                        });
                    });

                    if (applied) {
                        this.guardarDatosCupon();
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            setDescuento(descuento) {
                this.items.forEach(item => {
                    this.$set(item, 'discount', null);
                });

                if(descuento) {
                    this.items.forEach((item, index) => {
                        if (index < descuento.limit) {
                            this.$set(item, 'discount', {
                                id: descuento.id,
                                percentage: descuento.percentage,
                                name: descuento.name,
                                code: descuento.code,
                                licensorEntitlementId: descuento.licensorEntitlementId
                            });
                        }
                    });
                }

                this.guardarDatosCupon();
            },
            volver() {
                this.items.forEach(item => {
                    delete item.discount;
                });

                this.$emit('volver');
            },
            guardarDatosCupon() {
                this.loading = true;

                const params = {
                    cart_id: this.cart_id,
                    items: this.items.map(entrada => {
                        let discount = entrada.discount ? { ...entrada.discount } : [];

                        if (discount && !discount.licensorEntitlementId) {
                            delete discount.licensorEntitlementId;
                        }

                        return {
                            id: entrada.id,
                            discount
                        };
                    })
                };

                this.$store.dispatch(this.config.getVuexAlias('sga.cart.descuentos-codigo.guardar'), params).then(res => {
                    this.solicitarDatosCobro();
                }).catch(error => {
                    
                });
            },
            solicitarDatosCobro() {
                const params = {
                    filters: {},
                    cart_id: this.cart_id
                }

                this.$store.dispatch(this.config.getVuexAlias('sga.cart.solicitar-cobro'), params).then(res => {
                    this.$emit('setDatosCobro', res.data.jet_id, res.data.formulario, res.data.session_id, res.data.cart_id);
                }).finally(() => {
                    this.loading = false;
                });
            },
            desactivarCuponGeneral() {
                this.items.forEach(item => {
                    this.$set(item, 'discount', null);
                });

                this.getDescuentosCondicionales();
            }
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            total_con_gastos() {
                return this.items.reduce((acc, item) => acc + this.getTotal(item, true), 0);
            },
            total_sin_gastos() {
                return this.items.reduce((acc, item) => acc + this.getTotal(item, false), 0);
            },
            total_gastos() {
                return this.items.reduce((acc, item) => {
                    const p = item.precio;
                    return !p.price_management_interno ? acc + p.price_management : acc;
                }, 0);
            }
        },
        components: {
            FormTerminos,
            ResumenPrecioComponent,
            CuponDescuentoComponent
        }
    };
</script>
